/** Sets up MessageMedia themes based on the origin, or MM if unknown. */
export async function setupMessageMediaThemes() {
  const { runTimeThemeInjection } = await import(
    "@sinch-smb/theme-plugin/dist/lib/runtime-theme-injection"
  );

  runTimeThemeInjection({ staticPath: "/static/themes/runtime" });
}

export async function setVendorLabel() {
  const { getVendorByHostName } = await import(
    "@sinch-smb/theme-plugin/dist/lib/runtime-theme-injection"
  );
  // Make it available to the hub...
  window.VENDOR_LABEL = getVendorByHostName(window.location.origin) || "mm";
}
